import { Inject, Injectable, InjectionToken } from '@angular/core';
import type EstensaModel from 'estensa-module';
import { constant } from 'lodash-es';

export const BROKER_MODULE_BROKER_SERVICE = new InjectionToken('broker.module.broker.service');

export interface IBrokerServiceNg1 {
    findStudies(searchParams: EstensaModel.BrokerDataFilterStudy): { $promise: Promise<EstensaModel.BrokerDataStudy[]> };
}

@Injectable()
export class NullBrokerService implements IBrokerServiceNg1 {
    findStudies = constant({ $promise: Promise.resolve(null) });
}

@Injectable({
    providedIn: 'root',
})
export class BrokerService implements IBrokerServiceNg1 {
    constructor(@Inject(BROKER_MODULE_BROKER_SERVICE) private brokerService: IBrokerServiceNg1) { }
    findStudies(searchParams: EstensaModel.BrokerDataFilterStudy) {

        return this.brokerService.findStudies(searchParams) ;
    }
}


